export default __webpack_public_path__ + "static/strands-d9ccedee979f1136ef2329c19f713b10.png";